import { render, staticRenderFns } from "./PopularityIndexDetails.vue?vue&type=template&id=5f430ece&scoped=true"
import script from "./PopularityIndexDetails.vue?vue&type=script&lang=js"
export * from "./PopularityIndexDetails.vue?vue&type=script&lang=js"
import style0 from "./PopularityIndexDetails.vue?vue&type=style&index=0&id=5f430ece&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f430ece",
  null
  
)

export default component.exports